<script lang="ts" setup>
import { computed } from 'vue';
import { SampleType } from '@/gql/graphql';
import { BBadge, BModal, BTooltip } from 'bootstrap-vue-next';

// --- Component properties ---
const props = defineProps<{
  show: boolean;
  sample: SampleType;
}>();

// --- Component emits ---
const emits = defineEmits(['close']);

const show = computed<boolean>(() => {
  return props.show;
});

function handleCloseModal() {
  emits('close');
}
</script>
<template>
  <div>
    <!-- MODAL: Storage Object Rename -->
    <b-modal v-model="show" @hide="handleCloseModal">
      <!-- Modal Title -->
      <template #title>
        <font-awesome-icon icon="flask" class="me-2" />
        <strong>{{ sample?.name }}</strong> sample details
      </template>
      <!-- Modal Content -->
      <div v-if="sample">
        <p class="mb-1">
          <font-awesome-icon icon="tag" class="me-2" />
          <strong>Name: </strong>
          {{ sample.name }}
        </p>
        <p class="mb-1" v-if="sample.description">
          <font-awesome-icon icon="info-circle" class="me-2" />
          <strong>Description: </strong>
          {{ sample.description }}
        </p>
        <p class="mb-1">
          <font-awesome-icon icon="file-lines" class="me-2" />
          <strong>File R1: </strong> {{ sample.fileR1 }}
        </p>
        <p class="mb-1">
          <font-awesome-icon icon="file-lines" class="me-2" />
          <strong>File R2: </strong> {{ sample.fileR2 }}
        </p>
        <p class="mb-1">
          <font-awesome-icon icon="fas fa-cube" class="me-2" />
          <strong>Kit: </strong>
          <template v-if="sample.kit">
            {{ sample.kit.name }}
            <font-awesome-icon
              id="kit-desc-icon"
              icon="circle-info"
              v-if="sample.kit.description"
            />
            <BTooltip target="kit-desc-icon">
              {{ sample.kit.description }}
            </BTooltip>
            <BBadge
              v-if="sample.kit.code?.code"
              variant="warning"
              class="ms-1"
              id="kit-code-badge"
            >
              <font-awesome-icon icon="barcode" class="me-2" />
              {{ sample.kit.code.code }}
            </BBadge>
            <BTooltip target="kit-code-badge">kit code</BTooltip>
            <BBadge variant="success" class="ms-1" id="kit-version-badge">
              <font-awesome-icon icon="v" class="me-2" />
              {{ sample.kit.version ? sample.kit.version : 'not specified' }}
            </BBadge>
            <BTooltip target="kit-version-badge">version</BTooltip>
          </template>
          <template v-else> unspecified</template>
        </p>
        <p class="mb-1" v-if="sample.kit">
          <font-awesome-icon icon="barcode" class="me-2" />
          <strong>Barcode: </strong>
          <span v-if="sample.kit"> {{ sample.kit.barcode }}</span>
          <span v-else> unspecified</span>
        </p>
        <p class="mb-1" v-if="sample.kit">
          <font-awesome-icon icon="hashtag" class="me-2" />
          <strong>UMI length: </strong>
          <span v-if="sample.kit"> {{ sample.kit.umiLength }}</span>
          <span v-else> unspecified</span>
        </p>
      </div>
    </b-modal>
  </div>
</template>
